import { createFileRoute } from "@tanstack/react-router";
import { Customers } from "@/pages/team/Customers";

export const Route = createFileRoute("/_angemeldet/_mitarbeiter/kunden")({
	component: Customers,
});
